import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "row"]

  toggle(event) {
    event.preventDefault()
    this.rowTarget.classList.toggle("hidden")
    if (!this.rowTarget.classList.contains("hidden")) {
      this.inputTarget.focus()
    }
  }
}
